import React, { useContext, useState, createContext } from 'react';
export type ThemeType = 'light' | 'dark';

interface ThemeContextType {
  setTheme: React.Dispatch<React.SetStateAction<ThemeType>>;
  theme: ThemeType;
}

const ThemeContext = createContext<ThemeContextType | null>(null);

export const useThemeContext = () => {
  const currentThemeContext = useContext(ThemeContext);
  if (!currentThemeContext) {
    throw new Error('useThemeContext has to be used within <ThemeProvider>');
  }
  return currentThemeContext;
};

export const ThemeProvider = ({ children }: { children: JSX.Element }) => {
  const storedTheme = localStorage.getItem('colorMode') as ThemeType | null;
  const [theme, setTheme] = useState<ThemeType>(storedTheme || 'light');

  return (
    <ThemeContext.Provider
      value={{
        setTheme: (newTheme: ThemeType) => {
          setTheme(newTheme);
          localStorage.setItem('colorMode', newTheme);
        },
        theme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};
